export default {
  block: 'Blok',
  blocks: 'Bloklar',
  newBlock: 'Yeni Blok',
  editBlock: 'Blok Düzenle',
  blockId: 'Blok ID',
  blockIdRequired: 'Blok ID gereklidir',
  blockIdHelp: 'Sistemde benzersiz tanımlayıcı',
  displayName: 'Görünen İsim',
  displayNameRequired: 'Görünen isim gereklidir',
  displayNameHelp: 'Görsel arayüzde gösterilecek isim',

  // Assignment scope
  assignmentScope: 'Rota seferlerini seçilen bloğa ekle',
  onDate: 'Belirli bir tarihte',
  betweenDates: 'Tarih aralığında',
  permanently: 'Kalıcı olarak',
  endDateMustBeAfterStartDate: 'Bitiş tarihi başlangıç tarihinden sonra olmalıdır',
  selectDateRequired: 'Lütfen bir tarih seçin',
  selectDaysRequired: 'Lütfen en az bir gün seçin',
  selectTripsRequired: 'Lütfen en az bir sefer seçin',
  selectBlockRequired: 'Lütfen bir blok seçin',

  // Day selection
  selectDays: 'Gün Seçimi',
  weekdays: 'Hafta İçi',

  // Trip selection
  selectTrips: 'Sefer Seçimi',
  noTripsAvailable: 'Uygun sefer bulunmuyor',
  selectBlock: 'Blok Seç',
  selectBlockPlaceholder: 'Bir blok seçin',
  addBlock: 'Blok Ekle',

  // Assignment preview
  assignmentPreview: 'Atama Önizlemesi',
  noAssignments: 'Henüz atama yapılmadı',
  days: 'Günler',
  trips: 'Seferler',
  departure: 'Kalkış',
  currentBlock: 'Mevcut Blok',
  newBlockAssignment: 'Yeni Blok',

  // Delete confirmation
  deleteBlockTitle: 'Blok Silme Onayı',
  deleteBlockMessage:
    'Bu bloğa atanmış seferler bulunmaktadır. Silme işlemi öncesinde ilgili seferleri kontrol ediniz.',
  deleteBlockConfirm: 'Bloğu Sil',

  // Success/Error messages
  blockCreated: 'Blok başarıyla oluşturuldu',
  blockUpdated: 'Blok başarıyla güncellendi',
  blockDeleted: 'Blok başarıyla silindi',
  blockAssigned: 'Blok ataması başarıyla yapıldı',
  blockCreateError: 'Blok oluşturulurken hata oluştu',
  blockUpdateError: 'Blok güncellenirken hata oluştu',
  blockDeleteError: 'Blok silinirken hata oluştu',
  blockAssignError: 'Blok atanırken hata oluştu',
  blockAssignConflict: 'Blok atamasında çakışma tespit edildi',
};
